import React, { useState } from 'react';
import TopBar from '../TopBar/TopBar';
import Drawer from '../NavigationDrawer/index';

interface LayoutProps {
  children: React.ReactNode;
  title: React.ReactNode;
  showBackIcon?: boolean;
  isDarkMode?: boolean;
  navigateTo?: string;
}

const Layout: React.FC<LayoutProps> = ({
  children,
  title,
  showBackIcon = false,
  isDarkMode = false,
  navigateTo,
}) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <>
      <TopBar
        title={title}
        showBackIcon={showBackIcon}
        isDarkMode={isDarkMode}
        navigateTo={navigateTo}
        onMenuClick={() => setIsDrawerOpen(true)}
      />
      
      {children}
      
      <Drawer
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
      />
    </>
  );
};

export default Layout;
